/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.DepositAccount_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.DepositAccount domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum DepositAccount_ {
   /// <summary>
   ///    ()
   /// </summary>
   NotSpecified = 0,
   /// <summary>
   ///   CapStar (capstar)
   /// </summary>
   CapStar = 1,
   /// <summary>
   ///   Bank of America (boa)
   /// </summary>
   BankOfAmerica = 2
}

export const DepositAccounts: DepositAccount[] = [
   {
      code: DepositAccount_.NotSpecified,
      literal: 'NotSpecified',
      description: '',
      shortDescription: '',
      listPriority: 0,

      typeName: "DepositAccount"
   },
   {
      code: DepositAccount_.CapStar,
      literal: 'CapStar',
      description: 'CapStar',
      shortDescription: 'capstar',
      listPriority: 0,

      typeName: "DepositAccount"
   },
   {
      code: DepositAccount_.BankOfAmerica,
      literal: 'BankOfAmerica',
      description: 'Bank of America',
      shortDescription: 'boa',
      listPriority: 0,

      typeName: "DepositAccount"
   }
]

export class DepositAccount implements IDomainModel {
   code: DepositAccount_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: DepositAccount_): DepositAccount {
      return DepositAccounts.find(d => d.code === code)
   }
}
